import React from "react"
import PropTypes from "prop-types"
import {Route, Redirect} from "react-router-dom"

export const PrivateRoute = ({isAuthenticated, component: Component, ...rest}) => (
  <Route
    {...rest}
    component={(props) => (isAuthenticated ? <Component {...props} /> : <Redirect to="/" />)}
  />
)

PrivateRoute.propTypes = {
  isAuthenticated: PropTypes.bool,
  component: PropTypes.object
}

export default PrivateRoute
